import { getNavElements } from "consts";
import { usePolicyDetail, useSelectedPolicy } from "data/ss-data-hooks";

const HIDE_PROPERTY_CARRIERS = ["vave", "markel"];

export const useNavItems = () => {
  const { data } = useSelectedPolicy();
  const { data: detailData } = usePolicyDetail();
  const hidePropertyTab =
    data?.isCommercial ||
    HIDE_PROPERTY_CARRIERS.includes(
      detailData?.userPolicyProperties.carrierGroup?.toLowerCase() ?? "",
    );

  return getNavElements(hidePropertyTab);
};
